import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './VendorDashboard.css';
import vendorDashboardService from '../../services/vendorDashboardService';

const VendorDashboard = () => {
  const navigate = useNavigate();
  const [filters, setFilters] = useState({
    status: '',
    priority: '',
    search: '',
    page: 1,
    limit: 12
  });
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    loadData()
  }, [])


  const loadData = async () => {
    try {
      setLoading(true);
      const data = await vendorDashboardService.getVendorStats();
      setStats(data);
    } catch (error) {
      console.error('Error loading project dashboard:', error);
    } finally {
      setLoading(false);
    }
  };

  // Simple static data for testing
  const statsData = {
    tasks: {
      total: 0,
      completed: 0,
      inProgress: 0,
      pending: 0,
      blocked: 0
    },
    issues: {
      total: 0,
      open: 0,
      inProgress: 0,
      resolved: 0,
      closed: 0
    },
    projects: {
      active: 0
    },
    coVendors: {
      count: 0
    },
    contracts: {
      total: 0
    },
    performance: {
      completionRate: 0
    }
  };
  const [stats, setStats] = useState(statsData);

  return (
    <div className="vendor-dashboard">
      {/* Header */}
      <div className="dashboard-header">
        <div className="header-content">
          <h1>Tenants Dashboard</h1>
          <p className="header-subtitle">Welcome back! Here's your project overview</p>
        </div>
        <div className="header-actions">
          <button className="btn-refresh" onClick={() => window.location.reload()}>
            <i className="fas fa-sync-alt"></i> Refresh
          </button>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="stats-grid">
        {/* Tasks Card */}
        <div className="stat-card tasks-card">
          <div className="stat-icon">
            <i className="fas fa-tasks"></i>
          </div>
          <div className="stat-content">
            <h3>Tasks</h3>
            <div className="stat-number">{stats.tasks.total}</div>
            <div className="stat-breakdown">
              <span className="stat-item">
                <span className="dot" style={{ backgroundColor: '#3b82f6' }}></span>
                In Progress: {stats.tasks.inProgress}
              </span>
              <span className="stat-item">
                <span className="dot" style={{ backgroundColor: '#f59e0b' }}></span>
                Pending: {stats.tasks.pending}
              </span>
              <span className="stat-item">
                <span className="dot" style={{ backgroundColor: '#10b981' }}></span>
                Completed: {stats.tasks.completed}
              </span>
            </div>
          </div>
          <button
            className="stat-action"
            onClick={() => navigate('/vendor/tasks')}
          >
            View All <i className="fas fa-arrow-right blue-icon"></i>
          </button>
        </div>

        {/* Issues Card */}
        <div className="stat-card issues-card">
          <div className="stat-icon">
            <i className="fas fa-exclamation-circle"></i>
          </div>
          <div className="stat-content">
            <h3>Issues</h3>
            <div className="stat-number">{stats.issues.total}</div>
            <div className="stat-breakdown">
              <span className="stat-item">
                <span className="dot" style={{ backgroundColor: '#f59e0b' }}></span>
                Open: {stats.issues.open}
              </span>
              <span className="stat-item">
                <span className="dot" style={{ backgroundColor: '#3b82f6' }}></span>
                In Progress: {stats.issues.inProgress}
              </span>
              <span className="stat-item">
                <span className="dot" style={{ backgroundColor: '#10b981' }}></span>
                Resolved: {stats.issues.resolved}
              </span>
            </div>
          </div>
          <button
            className="stat-action"
            onClick={() => navigate('/vendor/issues')}
          >
            View All <i className="fas fa-arrow-right blue-icon"></i>
          </button>
        </div>

        {/* Projects Card */}
        <div className="stat-card projects-card">
          <div className="stat-icon">
            <i className="fas fa-project-diagram"></i>
          </div>
          <div className="stat-content">
            <h3>Active Projects</h3>
            <div className="stat-number">{stats.projects.active}</div>
            <div className="stat-description">
              Projects you're currently working on
            </div>
          </div>
          <button
            className="stat-action"
            onClick={() => navigate('/vendor/projects')}
          >
            View All <i className="fas fa-arrow-right blue-icon"></i>
          </button>
        </div>

        {/* Co-Vendors Card */}
        <div className="stat-card covendors-card">
          <div className="stat-icon">
            <i className="fas fa-users"></i>
          </div>
          <div className="stat-content">
            <h3>Co-Tenants</h3>
            <div className="stat-number">{stats.coVendors.count}</div>
            <div className="stat-description">
              Tenants working on same projects
            </div>
          </div>
          <button
            className="stat-action"
            onClick={() => navigate('/vendor/co-vendors')}
          >
            View All <i className="fas fa-arrow-right blue-icon"></i>
          </button>
        </div>

        <div className="stat-card covendors-card">
          <div className="stat-icon">
            <i class="fa-solid fa-file-contract"></i>

          </div>
          <div className="stat-content">
            <h3>Contracts</h3>
            <div className="stat-number">{stats.contracts.total}</div>
            <div className="stat-description">
              Tenants working on same projects
            </div>
          </div>
          <button
            className="stat-action"
            onClick={() => navigate('/vendor/contracts')}
          >
            View All <i className="fas fa-arrow-right blue-icon"></i>
          </button>
        </div>
      </div>





      {/* Performance Card */}
      <div className="performance-section">
        <div className="performance-card">
          <h3>
            <i className="fas fa-chart-line"></i> Performance Metrics
          </h3>
          <div className="performance-content">
            <div className="performance-item">
              <div className="performance-label">Task Completion Rate</div>
              <div className="performance-bar">
                <div
                  className="performance-fill"
                  style={{ width: `${stats.performance.completionRate}%` }}
                ></div>
              </div>
              <div className="performance-value">{stats.performance.completionRate}%</div>
            </div>
          </div>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="quick-actions">
        <h3>Quick Actions</h3>
        <div className="actions-grid">
          <button
            className="action-btn"
            onClick={() => navigate('/vendor/tasks')}
          >
            <i className="fas fa-tasks"></i>
            <span className="action-text">View Tasks</span>
          </button>
          <button
            className="action-btn"
            onClick={() => navigate('/vendor/issues')}
          >
            <i className="fas fa-exclamation-circle"></i>
            <span className="action-text">View Issues</span>
          </button>
          <button
            className="action-btn"
            onClick={() => navigate('/vendor/portal')}
          >
            <i className="fas fa-comments"></i>
            <span className="action-text">View Messages</span>
          </button>
          <button
            className="action-btn"
            onClick={() => navigate('/vendor/co-vendors')}
          >
            <i className="fas fa-users"></i>
            <span className="action-text">View Co-Tenants</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default VendorDashboard;

